<div class="drawer-layer drawer-layer-{{position}} {{ !isClosed ? 'opened' : 'hidden'}} {{ embedded ? 'drawer-layer-embedded' : ''}} {{ forcePadding ? 'no-white-bg' : ''}}"
	mwlResizable [ngStyle]="style" [enableGhostResize]="true" [resizeEdges]="resizeEdges"
	(resizeEnd)="onResizeEnd($event)" cdkDrag [cdkDragDisabled]="position !== 'flying'">
	<div *ngIf="showHeader" class="drawer-layer-header {{(embedded && !forcePadding) ? 'p-0' : ''}}">
		<div class="drawer-layer-header-title">
			<h1>{{title | translate}}</h1>
			<span *ngIf="contextLabel" class="drawer-context-label"
				[ngClass]="'drawer-context-label--' + contextVariant"
				[attr.title]="contextLabelTooltip ? (contextLabelTooltip | translate) : null" [innerHTML]="contextLabel | translate">
			</span>
		</div>
		<div class="drawer-layer-header-buttons">
			<div class="drawer-layer-header-buttons-section">
				<div *ngIf="showToggle" class="d-flex align-items-center mr-auto">
					<toggle-switch [toggled]="toggleValue" [label]="toggleLabel | translate"
						[containerClass]="'toggle-switch-field'"
						(toggledChange)="onToggleChange($event)"></toggle-switch>
				</div>
				<a class="btn btn-icon btn-big-icon" *ngIf="position === 'flying'" cdkDragHandle>
					<i class="fas fa-up-down-left-right"></i>
				</a>
				<a *ngIf="!embedded" class="btn btn-icon btn-big-icon" [popover]="positionPopover" placement="'left'"
					containerClass="position-popover" container="body" triggers="click" [outsideClick]="true"
					#pop="bs-popover" (click)="$event.preventDefault(); $event.stopPropagation();">
					<i class="fas fa-ellipsis-v"></i>
				</a>
				<a class="btn btn-icon btn-big-icon" tooltip="Close" placement="left" (click)="close();"><i
						class="far fa-times closer"></i></a>
			</div>
			<div class="drawer-layer-header-buttons-section">
				<confirmation-popover *ngIf="!loading && showHeaderButtons && !hideDelete" class="d-flex"
					placement="bottom"
					className="far fa-trash btn-circle-icon btn-circle-medium btn-circle-reversed btn-danger"
					(onConfirmed)="deleteRequest()"></confirmation-popover>
				<button *ngIf="showHeaderButtons && !hideCancel" (click)="cancelRequest();"
					class="btn btn-default {{loading ? 'disabled' : ''}}">{{ cancelLabel | translate }}</button>
				<button *ngIf="showHeaderButtons && !hideSave" (click)="saveRequest();"
					class="btn btn-primary {{loading ? 'disabled' : ''}}">{{ saveLabel | translate }}</button>
				<confirmation-popover *ngIf="showHeaderButtons && saveWithConfirmation" class="d-flex"
					placement="bottom" className="{{saveWithConfirmationClasses}}" [label]="saveWithConfirmationLabel"
					[question]="saveWithConfirmationQuestion"
					(onConfirmed)="saveWithConfirmationRequest()"></confirmation-popover>
			</div>
		</div>
	</div>
	<div class="d-inline-flex m-auto align-content-center" *ngIf="loading">
		<i class="fad fa-spinner-third fa-spin fa-2x mt-5 ml-5"></i>
	</div>
	<div class="drawer-layer-content {{(noContentPadding || (embedded && !forcePadding)) ? 'p-0' : 'px-4 pb-4'}}"
		*ngIf="!loading"
		(scroll)="onContentScroll()">
		<ng-content></ng-content>
	</div>
</div>

<ng-template #positionPopover>
	<div class="popover-buttons popover-buttons-bar">
		<button *ngIf="!embedded && showHeader" class="btn d-block btn-link {{position === 'top' ? 'active' : ''}}"
			tooltip="{{'Top' | translate}}" placement="right" (click)="changePosition('top');">
			<i class="fal fa-rectangle-history fa-rotate-180"></i>
		</button>
		<button *ngIf="!embedded && showHeader" class="btn d-block btn-link {{position === 'right' ? 'active' : ''}}"
			tooltip="{{'Right' | translate}}" placement="right" (click)="changePosition('right');">
			<i class="fal fa-rectangle-vertical-history"></i>
		</button>
		<button *ngIf="!embedded && showHeader" class="btn d-block btn-link {{position === 'bottom' ? 'active' : ''}}"
			tooltip="{{'Bottom' | translate}}" placement="right" (click)="changePosition('bottom');">
			<i class="fal fa-rectangle-history"></i>
		</button>
		<button *ngIf="!embedded && showHeader" class="btn d-block btn-link {{position === 'left' ? 'active' : ''}}"
			tooltip="{{'Left' | translate}}" placement="right" (click)="changePosition('left');">
			<i class="fal fa-rectangle-vertical-history fa-rotate-180"></i>
		</button>
		<button *ngIf="!embedded && showHeader" class="btn d-block btn-link {{position === 'flying' ? 'active' : ''}}"
			tooltip="{{'Flying' | translate}}" placement="right" (click)="changePosition('flying');">
			<i class="fal fa-up-down-left-right"></i>
		</button>
	</div>
</ng-template>
